import { createSlice } from '@reduxjs/toolkit'

import { cancelSubscription } from 'common/billing/actions/billingActions'
import {
  fetchWinBackDiscount,
  startCancelSubscription,
} from 'common/billing/actions/cancellationActions'
import { PaywallOffering } from 'shared/api/requests/billing/schemas'

export interface CancellationState {
  isOpen: boolean
  isCancelled: boolean
  loading: boolean
  error: boolean
  offer: PaywallOffering | null
  offeringHash: string | null
}

const initialState: CancellationState = {
  isOpen: false,
  isCancelled: false,
  loading: false,
  error: false,
  offer: null,
  offeringHash: null,
}

export const cancellationSlice = createSlice({
  name: 'cancellation',
  initialState,
  reducers: {
    open: (state) => {
      state.isOpen = true
    },
    close: () => initialState,
    toggle: (state) => {
      state.isOpen = !state.isOpen
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWinBackDiscount.pending, (state) => {
        state.loading = true
        state.error = false
      })
      .addCase(fetchWinBackDiscount.fulfilled, (state, action) => {
        state.loading = false
        state.offer = action.payload.offer
        state.offeringHash = action.payload.offering_hash
      })
      .addCase(fetchWinBackDiscount.rejected, (state) => {
        state.loading = false
        state.error = true
      })
      .addCase(cancelSubscription.fulfilled, (state) => {
        state.isCancelled = true
      })
      .addCase(startCancelSubscription.fulfilled, (state, action) => {
        if (action.payload) {
          state.isOpen = true
        }
      })
  },
})

export const cancellationActions = cancellationSlice.actions
